"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _chevronLeftDisabled = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-left-disabled.svg"));
var _chevronRightDisabled = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right-disabled.svg"));
var _chevronLeft = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-left.svg"));
var _chevronRight = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Global components
 * By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB pagination
 */

/**
 * SVBPagination
 * @param {number} [totalPages = 10] - Total number of pages
 * @param {number} [currentPage = 1] - Current page displayed
 * @param {function} [setCurrentPage = setPage] - setState function to change the value of the current page
 * @param {string} [extraClasses = ''] - Extra classes to be added to the div element wrapping the pagination content
 * @returns JSX element
 */

const SVBPagination = props => {
  const [page, setPage] = (0, _react.useState)(1);
  const totalPages = props.totalPages || 10; //Required
  const currentPage = props.currentPage || page; //Required
  const setCurrentPage = props.setCurrentPage || setPage; //Required
  const extraClasses = props.extraClasses || '';
  const renderContent = (totalPages, currentPage, setCurrentPage) => {
    const renderArray = [];
    if (currentPage !== 1) renderArray.push( /*#__PURE__*/_react.default.createElement("img", {
      src: _chevronLeft.default,
      key: "prev",
      onClick: () => setCurrentPage(prev => prev - 1)
    }));else renderArray.push( /*#__PURE__*/_react.default.createElement("img", {
      src: _chevronLeftDisabled.default,
      key: "prev",
      className: "svb-pagination_disabled"
    }));
    if (totalPages < 5) for (let i = 1; i <= totalPages; i++) {
      renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
        key: i,
        className: "".concat(i === currentPage && 'svb-pagination_selected'),
        onClick: () => setCurrentPage(i)
      }, i));
    } else {
      // Left
      if (currentPage === 1 || currentPage === 2) {
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: 1,
          className: "".concat(currentPage === 1 && 'svb-pagination_selected'),
          onClick: () => setCurrentPage(1)
        }, 1));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: 2,
          className: "".concat(currentPage === 2 && 'svb-pagination_selected'),
          onClick: () => setCurrentPage(2)
        }, 2));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: 3,
          onClick: () => setCurrentPage(3)
        }, 3));
      } else {
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: 1,
          onClick: () => setCurrentPage(1)
        }, 1));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: "rest-left",
          className: "svb-pagination_rest"
        }, "..."));
      }
      // Right
      if (currentPage === totalPages || currentPage === totalPages - 1) {
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: totalPages - 2,
          onClick: () => setCurrentPage(totalPages - 2)
        }, totalPages - 2));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: totalPages - 1,
          className: "".concat(currentPage === totalPages - 1 && 'svb-pagination_selected'),
          onClick: () => setCurrentPage(totalPages - 1)
        }, totalPages - 1));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: totalPages,
          className: "".concat(currentPage === totalPages && 'svb-pagination_selected'),
          onClick: () => setCurrentPage(totalPages)
        }, totalPages));
      } else if (currentPage + 2 <= totalPages && currentPage !== 1 && currentPage !== 2) {
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: currentPage - 1,
          onClick: () => setCurrentPage(currentPage - 1)
        }, currentPage - 1));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: currentPage,
          className: "svb-pagination_selected",
          onClick: () => setCurrentPage(currentPage)
        }, currentPage));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: currentPage + 1,
          onClick: () => setCurrentPage(currentPage + 1)
        }, currentPage + 1));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: "rest-right",
          className: "svb-pagination_rest"
        }, "..."));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: totalPages,
          onClick: () => setCurrentPage(totalPages)
        }, totalPages));
      } else {
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: "rest-right",
          className: "svb-pagination_rest"
        }, "..."));
        renderArray.push( /*#__PURE__*/_react.default.createElement("p", {
          key: totalPages,
          onClick: () => setCurrentPage(totalPages)
        }, totalPages));
      }
    }
    if (currentPage !== totalPages) renderArray.push( /*#__PURE__*/_react.default.createElement("img", {
      src: _chevronRight.default,
      key: "next",
      onClick: () => setCurrentPage(prev => prev + 1)
    }));else renderArray.push( /*#__PURE__*/_react.default.createElement("img", {
      src: _chevronRightDisabled.default,
      key: "next",
      className: "svb-pagination_disabled"
    }));
    return renderArray;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-pagination ".concat(extraClasses)
  }, renderContent(totalPages, currentPage, setCurrentPage));
};
var _default = SVBPagination;
exports.default = _default;